/* eslint-disable eslint-comments/disable-enable-pair */

/* eslint-disable import/no-cycle */
import React from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { SbBlokData } from "@storyblok/react";
import clsx from "clsx";
import { useAuth } from "../context/AuthContext";
import { CommonDataContext } from "../context/CommonDataContext";
import PNRWidget from "./PNRWidget/PNRWidget";

const Components = {
  accordianSection: dynamic(() => import("./FooterWithAccordian")),
  button: dynamic(() => import("./Button")),
  collapsPanel: dynamic(() => import("./collapsPanel")),
  contactUsForm: dynamic(() => import("./ContactUsForm/ContactUsForm"), {
    ssr: false
  }),
  container: dynamic(() => import("./Container")),
  copyRights: dynamic(() => import("./CopyRights")),
  customerSupportCard: dynamic(() => import("./customerSupportCard/index")),
  DownloadApp: dynamic(() => import("./DownloadApp")),
  footerComponent: dynamic(() => import("./FooterComponent")),
  goToActionBar: dynamic(() => import("./GoToActionBar")),
  grid: dynamic(() => import("./Grid")),
  grid2x2: dynamic(() => import("./Grid2x2")),
  grid3x1: dynamic(() => import("./Grid3x1")),
  grid4x1: dynamic(() => import("./Grid4x1")),
  grid6x1: dynamic(() => import("./Grid6x1")),
  groupBooking: dynamic(() => import("./GroupBooking")),

  h1: dynamic(() => import("./H1")),
  h2: dynamic(() => import("./H2")),
  h3: dynamic(() => import("./H3")),
  h4: dynamic(() => import("./H4")),
  h5: dynamic(() => import("./H5")),
  h6: dynamic(() => import("./H6")),
  p: dynamic(() => import("./P")),

  HeroCarouse: dynamic(() => import("./HeroCarousel")),
  icons: dynamic(() => import("./Icons")),
  image: dynamic(() => import("./image")),
  label: dynamic(() => import("./Label")),
  labelWithContent: dynamic(() => import("./LabelWithContent")),
  linksComponent: dynamic(() => import("./LinksComponent")),
  loginCTA: dynamic(() => import("./LoginCTA")),

  navBar: dynamic(() => import("./Navbar")),
  navBarDropDown: dynamic(() => import("./NavBarDropDown")),
  navBarLogo: dynamic(() => import("./NavBarLogo/NavBarLogo")),
  normalLinks: dynamic(() => import("./NormalLinks")),

  page: dynamic(() => import("./Page")),
  path: dynamic(() => import("./Breadcrumbs/Breadcrumbs")),
  plainText: dynamic(() => import("./Plaintext")),

  pnrWidget: dynamic(() => import("./PNRWidget/PNRWidget"), {
    ssr: false
  }),

  refundWidget: dynamic(() => import("./RefundWidget/RefundWidget"), {
    ssr: false
  }),

  richEditor: dynamic(() => import("./richEditor")),
  searchWidgetPanel: dynamic(() => import("./SearchPanel/SearchPanel")),
  socialIcons: dynamic(() => import("./SocialIcons")),
  tabs: dynamic(() => import("./Tabs")),
  textAndImageWithLink: dynamic(() => import("./TextAndImageWithLink/index")),
  textEditor: dynamic(() => import("./textEditor")),
  textWithImage: dynamic(() => import("./TextWithImage")),

  "Carousel With Center Navigation": dynamic(() => import("./CarouselWithCenterNavigation")),
  availableFlights: dynamic(() => import("./ListOfFlights")),
  undoCheckIn: dynamic(() => import("./UndoCheckIn/UndoCheckInLandingPage/UndoCheckIn")),
  specialRequestPanel: dynamic(() => import("./SpecialRequestLandingPage/SpecialRequestPanel")),

  Boarding_Pass: dynamic(() => import("./BoardingPass")),
  CustomRichEditor: dynamic(() => import("./CustomRichEditor")),
  GridItems: dynamic(() => import("../atom/GridItems/GridItems")),
  PageNotFound: dynamic(() => import("./PageNotFound/PageNotFound")),
  QuickLinks: dynamic(() => import("./QuickLinks/QuickLinks")),
  PageNotFoundContent: dynamic(() => import("./PageNotFoundContent/PageNotFoundContent")),
  flightStatusSearchWidget: dynamic(() => import("./FlightStatus/FlightStatus")),
  MyUpcomingFlights: dynamic(() => import("./MyUpcomingFlights/MyUpcomingFlights")),
  CancellationAndRefundPolicy: dynamic(() => import("./CancellationAndRefundPolicy/CancellationAndRefundPolicy")),
  AcceptingPaymentsCards: dynamic(() => import("./molecules/AcceptingPaymentsCards/AcceptingPaymentsCards")),

  "addons-checkins": dynamic(() => import("./CheckInAddons/CheckInAddons"), {
    ssr: false
  }), // CheckInAddons
  "checkin-successful": dynamic(() => import("./CheckIn/CheckInSuccessful")), // CheckinSuccessful
  "Dangerous-Goods": dynamic(() => import("./DangerousGoods/DangerousGoods"), {
    ssr: false
  }), // DangerousGoods
  "passenger-booking-process": dynamic(() => import("./passengerBookingProcess/index"), {
    ssr: false
  }), // PassengerBookingProcess
  "passenger-details": dynamic(() => import("./AddPassengerDetails/index"), {
    ssr: false
  }), // PassengersDeatils
  "successful-card": dynamic(() => import("./BookingSuccessfull/BookingSuccessfull"), {
    ssr: false
  }), // BookingSuccessfull
  aboutUsCarousel: dynamic(() => import("./AboutUsCarousel")), // AboutUsCarousel
  AddNewBusinessProfileModal: dynamic(() => import("./AddNewBusinessProfileModal/AddNewBusinessProfileModal"), {
    ssr: false
  }), // AddNewBusinessProfileModal

  bottomNavigation: dynamic(() => import("./BottomNavigation"), {
    ssr: false
  }), // BottomNav
  BusinessProfileModal: dynamic(() => import("./BusinessProfileModal/BusinessProfileModal"), {
    ssr: false
  }), // BusinessProfileModal
  callUsCard: dynamic(() => import("./CallUsCard/CallUsCard"), {
    ssr: false
  }), // CallUsCard
  editProfile: dynamic(() => import("./EditProfileComp/EditProfileForm"), {
    ssr: false
  }), // EditProfileForm
  eticket: dynamic(() => import("./ETicket/index"), {
    ssr: false
  }), // ETicket
  excessBaggage: dynamic(() => import("./ExcessBaggage")), // ExcessBaggage
  flightDetailsCard: dynamic(() => import("./AddPassengerDetails/FlightDetails/FlightDetails")),
  FlightDetailsModal: dynamic(() => import("./FlightDetailsModal/FlightDetailsModal"), {
    ssr: false
  }), // FlightDetailsModal

  LoginButton: dynamic(() => import("./LoginButton")),
  mobileLinksComponent: dynamic(() => import("./MobileLinkComponent"), {
    ssr: false
  }), // mobileLinksComponent
  modify_Search: dynamic(() => import("./modifySearch/index"), {
    ssr: false
  }), // ModifySearch
  notificationIcon: dynamic(() => import("./Notifications"), {
    ssr: false
  }), // Notifications
  personalisedExperience: dynamic(() => import("./PersonalisedExperience")), // PersonalisedExperience
  pocketPayment: dynamic(() => import("./PocketPayment")), // PocketPayment
  printBoardingPass: dynamic(() => import("./PrintBoardingPass/PrintBoardingPass"), {
    ssr: false
  }), // PrintBoardingPass
  profileCard: dynamic(() => import("./ProfileCard/ProfileCard"), {
    ssr: false
  }), // ProfileCard
  profileMenu: dynamic(() => import("./ProfileMenu/ProfileMenu"), {
    ssr: false
  }), // ProfileMenu
  quickAccessPanel: dynamic(() => import("./QuickAccessPannel")), // QuickAccessPannel
  readMore: dynamic(() => import("./ReadMore/index"), {
    ssr: false
  }), // readMore
  recentFlights: dynamic(() => import("./RecentFlights")), // RecentFlights,
  ReturnHome: dynamic(() => import("./ReturnToHome/index"), {
    ssr: false
  }), // ReturnToHome,
  subscribeMail: dynamic(() => import("./SubscribeMail"), {
    ssr: false
  }), // SubscribeMail
  CancelBookingModal: dynamic(() => import("./CancelBooking/CancelBookingModal/CancelBookingModal"), {
    ssr: false
  }), // CancelBookingModal
  CancelBookingPanel: dynamic(() => import("./CancelBooking/CancelBookingPanel/CancelBookingPanel"), {
    ssr: false
  }), // CancelBookingPanel
  checkinSummary: dynamic(() => import("./CheckIn/index"), {
    ssr: false
  }), // CheckIn,
  CheckInPaymentSummary: dynamic(() => import("./CheckInPaymentSummary/CheckInPaymentSummary"), {
    ssr: false
  }), // CheckInPaymentSummary
  checkInWidget: dynamic(() => import("./CheckInWidget/index"), {
    ssr: false
  }), // checkInWidget
  discountBanner: dynamic(() => import("./DiscountBanner"), {
    ssr: false
  }), // DiscountBanner
  paymentFailureCard: dynamic(() => import("./common/OnHoldErrorHandlingScreen"), {
    ssr: false
  }), // paymentFailureCard
  selectSeats: dynamic(() => import("./CheckIn/SeatSelection/index"), {
    ssr: false
  }), // CheckinSeatSelection
  successScreen: dynamic(() => import("./SuccessPage/index"), {
    ssr: false
  }), // SuccessPage
  tabsWithVideo: dynamic(() => import("./TabsWithVideo"), {
    ssr: false
  }), // TabsWithVideo,
  upcomingFlight: dynamic(() => import("./upcomingFlight")), // UpcomingFlight
  viewGSTInvoicePanel: dynamic(() => import("./ViewGSTInvoice/index"), {
    ssr: false
  }), // viewGSTInvoicePanel
  newsContentWithFilters: dynamic(() => import("./NewsContentWithFilters/index"), {
    ssr: false
  }), // NewsContentWithFilters,
  mobSearchPanel: dynamic(() => import("./MobileSearchPanel/index"), {
    ssr: false
  }), // mobSearchPanel
  clickableCardwithImage: dynamic(() => import("./ClickableCardWithImage/index"), {
    ssr: false
  }), // ClickableCardWithImage
  CancellationPolicyModal: dynamic(() => import("./CancellationPolicyModal/CancellationPolicyModal"), {
    ssr: false
  }), // CancellationPolicyModal
  CancelledPanel: dynamic(() => import("./CancelledPanel/CancelledPanel"), {
    ssr: false
  }), // CancelledPanel
  Changebookingmodal: dynamic(() => import("./Changebookingmodal/Changebookingmodal"), {
    ssr: false
  }), // Changebookingmodal
  feedback: dynamic(() => import("./Feedback"), {
    ssr: false
  }), // Feedback
  manageBookingAddOns: dynamic(() => import("./ModifyBookingPanel/ManageBookingAddOns"), {
    ssr: false
  }), // manageBookingAddOns
  manageBookingSeatSelection: dynamic(() => import("./ModifyBookingPanel/ManageBookingSeatSelection"), {
    ssr: false
  }), // manageBookingSeatSelection,
  manageBookingSuccess: dynamic(() => import("./ModifyBookingPanel/ManageBookingSuccess"), {
    ssr: false
  }), // manageBookingSuccess
  manageBookingSummary: dynamic(() => import("./ModifyBookingPanel/ManageBookingSummary"), {
    ssr: false
  }), // manageBookingSummary
  RetrieveBookingPanel: dynamic(() => import("./RetrieveBookingPanel/RetrieveBookingPanel"), {
    ssr: false
  }), // RetrieveBookingPanel
  UpdateDetailsModal: dynamic(() => import("./UpdateDetailsModal/UpdateDetailsModal"), {
    ssr: false
  }), // UpdateDetailsModal,
  searchIcon: dynamic(() => import("./SearchIcon")),
  NavigationBar: dynamic(() => import("./NavigationBar")),
  emailUnsubscription: dynamic(() => import("./EmailUnsubscription")),
  flightScheduleComponent: dynamic(() => import("./FlightSchedulePanel/FlightScheduleSearchWidget/FlightScheduleSearchWidget"), {
      ssr: false
    }),

  NeedMoreHelp: dynamic(() => import("./NeedMoreHelp/NeedMoreHelp")),
  ContactUs: dynamic(() => import("./ContactUs/ContactUs")),
  FeedbackForm: dynamic(() => import("./FeedbackForm/Feedback/Feedback")),


  InteractiveNetworkMap: dynamic(() => import("./InteractiveNetworkMap"), {
    ssr: false
  }),

  RichTextV2: dynamic(() => import("./V2/atoms/RichTextV2/RichTextV2")),
  ButtonV2: dynamic(() => import("./V2/atoms/ButtonV2/ButtonV2")),
  CardV2: dynamic(() => import("./V2/atoms/CardV2/CardV2")),
  GridV2: dynamic(() => import("./V2/atoms/GridV2/GridV2")),
  ImageV2: dynamic(() => import("./V2/atoms/ImageV2/ImageV2")),


  FooterV2: dynamic(() => import("./V2/molecules/FooterV2/FooterV2")),
  HeaderV2: dynamic(() => import("./V2/molecules/HeaderV2/HeaderV2")),
  FlightStatusButtonV2: dynamic(() => import("./V2/molecules/FlightStatusButtonV2/FlightStatusButtonV2")),
  HeroSectionV2: dynamic(() => import("./V2/molecules/HeroSectionV2/HeroSectionV2")),
  TabsV2: dynamic(() => import("./V2/molecules/TabsV2/TabsV2")),
  TabV2: dynamic(() => import("./V2/molecules/TabsV2/TabV2/TabV2")),
  TabsContentV2: dynamic(() => import("./V2/molecules/TabsV2/TabsContentV2/TabsContentV2")),

  CheckInButtonV2: dynamic(() => import("./V2/organisms/CheckIn/CheckInButtonV2/CheckInButtonV2")),
  BookAFlightButtonV2: dynamic(() => import("./V2/organisms/BookingAFlight/BookAFlightButtonV2/BookAFlightButtonV2")),
  MyBookingButtonV2: dynamic(() => import("./V2/organisms/ManageBookings/MyBookingButtonV2/MyBookingButtonV2")),
  FlightBookingWidgetV2: dynamic(() => import("./V2/organisms/BookingAFlight/FlightBookingWidgetV2/FlightBookingWidgetV2")),
  
  TravelCertificateV2: dynamic(() => import("./TravelCertificate/travelCertificate")),
  TravelCertificateWidgetV2: dynamic(() => import("./TravelCertificate/travelCertificateWidgetV2")),
  TravelCertficateSuccessful: dynamic(() => import("./TravelCertificate/travelCertficateSuccessful")),
  TravelCertificateView: dynamic(() => import("./TravelCertificate/travelCertificateView"))
};

interface DynamicComponentProps {
  blok: SbBlokData;
  config?: SbBlokData | null;
  resources?: SbBlokData | null;
}

function DynamicComponent({ blok, config = null, resources = null }: DynamicComponentProps) {
  const { userData } = useAuth();
  const { query } = useRouter();
  if (resources == null) {
    const commonContent = React.useContext(CommonDataContext);
    resources = commonContent.resources;
  }
  // Based on user type, checks if the component needs to be mounted
  const isVisible = (blok: { user_type: string | any[] }) => {
    if (blok?.user_type && blok?.user_type?.length > 0) {
      for (let i = 0; i < blok.user_type.length; i++) {
        if (userData[blok.user_type[i]]) return true;
      }
      return false;
    }
    return true;
  };
  // if the component exist return the component else return a placeholder
  if (typeof Components[blok?.component] !== "undefined") {
    const Component = Components[blok?.component];
    let displayClass = `ComponentName_${blok?.component} `;

    const blokClass = clsx({
      [displayClass]: true,
      "web-only":
        (blok?.device_type?.includes("web") && blok?.device_type?.length === 1) ||
        (blok?.device_type?.length > 0 && !blok?.device_type?.includes("mobile")),
      "mobile-only":
        (blok?.device_type?.includes("mobile") && blok?.device_type?.length === 1) ||
        (blok?.device_type?.length > 0 && !blok?.device_type?.includes("web")),
      "w-full": blok.fullWidth
    });

    let viewReference = blok._uid;
    if (blok?.component == "availableFlights" || blok?.component == "modify_Search") {
      viewReference = Math.random().toString();
    }

    return (
      <div key={viewReference} className={blokClass}>
        {/* checks if the device type and user type are same as the currentDevice and current user */}
        {isVisible(blok) ? <Component blok={blok} resourceData={resources} config={config} slug={query} /> : null}
      </div>
    );
  }
  return <div />;
}

export default DynamicComponent;
